
<template>
    <el-dialog
        :top="top"
        :height="dialogHeight"
        center
        :append-to-body="appendToBody"
        :closeOnClickModal="closeOnClickModal"
        :fullscreen="fullscreen"
        v-bind="$attrs"
        v-on="$listeners"
    >
        <slot name="title" slot="title"></slot>
        <div :style="{ height: bodyHeight + 'px' }" class="xtt-dialog-content">
            <slot :bodyHeight="bodyHeight"></slot>
        </div>
        <slot v-if="$slots.footer" name="footer" slot="footer"></slot>
    </el-dialog>
</template>

<script>
export default {
    name: 'XttDialog',
    props: {
        height: {
            type: Number,
            default: 580
        },
        headerHeight: {
            type: Number,
            default: 49
        },
        footerHeight: {
            type: Number,
            default: 58
        },
        closeOnClickModal: {
            type: Boolean,
            default: false
        },
        appendToBody: {
            type: Boolean,
            default: true
        },
        fullscreen: {
            type: Boolean,
            default: false
        }
    },
    inheritAttrs: false,
    data() {
        return {
            top: '20px',
            bodyHeight: 300
        };
    },
    created: function() {
        this.setBodyHeight();
    },
    methods: {
        /**
         * 设置弹框显示区域高度
         * @param {*} dialogObj
         */
        setBodyHeight() {
            let windowheight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            let offsetHeight = this.headerHeight + this.footerHeight;
            if (this.fullscreen) {
                this.bodyHeight = windowheight - offsetHeight;
            } else {
                // dialog最大高度
                let maxHeight = windowheight - 140;
                // 配置的dialog高度超过了最大高度，设置dialog的高度为最大高度
                let height = maxHeight > this.dialogHeight ? this.dialogHeight : maxHeight;
                this.bodyHeight = height - offsetHeight;
                this.top = (Math.abs(windowheight - height)) / 2 + 'px';
            }
        }
    },
    computed: {
        dialogHeight() {
            return this.height;
        }
    },
    watch: {
        height(val) {
            this.setBodyHeight();
        }
    }
};
</script>

<style scoped>
</style>
